import PoliciesSeverity from "./PoliciesSeverity/PoliciesSeverity";
import PoliciesTags from "./PoliciesTags/PoliciesTags";
import IQLPlayground from "./IQLPlayground/IQLPlayground";
import PoliciesNameDescription from "./PoliciesNameDescription/PoliciesNameDescription";

export default function PoliciesFormModalContent() {
  return (
    <div className="p-6">
      {/* Name + Description  */}
      <PoliciesNameDescription />

      {/* Severity + Tags */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <PoliciesSeverity />
        <PoliciesTags />
      </div>

      {/* Evaluation Criteria */}
      <IQLPlayground />
    </div>
  );
}
